import type { AttachmentFile } from 'owa-attachment-file-types';

let pendingInlineImages: AttachmentFile[] = [];

export function addPendingInlineImage(file: AttachmentFile) {
    pendingInlineImages.push(file);
}

export function getPendingInlineImages() {
    return pendingInlineImages;
}

export function clearPendingInlineImages() {
    pendingInlineImages = [];
}
